module.exports = __webpack_public_path__ + "static/media/7.9eb0961c.jpg";